const LANGUAGES = {
    ru: "ru",
    en: "en",
    es: "es",
    fr: "fr",
    de: "de",
    pl: "pl",
    ua: "ua",
};

const WIDGET_SCRIPTS = [
    "https://my.novofon.com/webphoneWebRTCWidget/v8/js/novofon/loader-phone-lib.js?sub_v=68",
    "https://my.novofon.com/webphoneWebRTCWidget/v8/js/loader-phone-fn.js?sub_v=68",
];

let scriptsPromise = null;

/**
 * Библиотека веб-телефонии грузится по требованию — только той мастерской,
 * у которой настроена интеграция. Раньше оба скрипта висели в index.html и
 * тянулись у всех: когда сервис телефонии недоступен, кабинет ждал их
 * загрузки и открывался с задержкой.
 */
function loadWidgetScripts() {
    if (scriptsPromise) return scriptsPromise;

    scriptsPromise = WIDGET_SCRIPTS.reduce(
        (chain, src) =>
            chain.then(
                () =>
                    new Promise((resolve) => {
                        const script = document.createElement("script");

                        script.src = src;
                        script.async = true;
                        // Недоступная телефония не должна ломать кабинет
                        script.onload = resolve;
                        script.onerror = resolve;

                        document.head.appendChild(script);
                    })
            ),
        Promise.resolve()
    );

    return scriptsPromise;
}

export function loadWebRTC(KEY, ATC) {
    loadWidgetScripts().then(() => {
        // Виджет объявляет свою функцию не сразу после загрузки файла
        const waitForWidget = setInterval(() => {
            if (window.zadarmaWidgetFn === undefined) return;

            window.zadarmaWidgetFn(
                KEY,
                ATC,
                "square",
                LANGUAGES[window.defaultLocale] || LANGUAGES.ru,
                true,
                { left: "10px", bottom: "5px" }
            );
            clearInterval(waitForWidget);
        }, 1000);

        // Не ждём вечно: если библиотека не поднялась за минуту — бросаем
        setTimeout(() => clearInterval(waitForWidget), 60000);
    });
}
